import useResponsive from '../../hooks/useResponsive';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/roles/rolePageHeader.css';

const EquipmentPageHeader = ({ setOpenAddEquipement, hasEquipementCreatePermission }) => {

    const { t } = useTranslation();
    const isDesktop = useResponsive('up', 'lg');

    const handleAddEquipment = useCallback(() => {
        setOpenAddEquipement(true);
    }, [setOpenAddEquipement]);

    return (
        <Box className='role_page_header_main_container'>
            <Box className='role_page_header_title_box'>
                <Typography className='role_page_header_page_title'>{t("Equipments")}</Typography>
            </Box>
            {isDesktop && hasEquipementCreatePermission &&
                <Box className='role_page_header_action_box' onClick={handleAddEquipment}>
                    <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='role_page_header_action_title'>{t("addEquipmentDialogTitle")}</Typography>
                </Box>
            }
            {!isDesktop &&
                <Box className='role_page_header_action_box'>
                    {hasEquipementCreatePermission && <Iconify className='role_page_header_add_icon' icon={"ic:baseline-plus"} onClick={handleAddEquipment} />}
                </Box>
            }
        </Box>
    );
};

export default React.memo(EquipmentPageHeader);